import React from "react";

export default function ShoppingBagIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.64704 26.0226C7.3478 20.018 8.37172 15.5157 9.32126 12.317C10.0999 9.69422 10.4892 8.38282 12.0857 7.1914C13.6821 6 15.3139 6 18.5775 6H29.4226C32.6862 6 34.318 6 35.9144 7.1914C37.5108 8.38282 37.9002 9.69422 38.6788 12.317C39.6284 15.5157 40.6522 20.018 41.353 26.0226C42.179 33.0994 42.5918 36.6378 40.2054 39.3188C37.819 42 33.9516 42 26.2168 42H21.7832C14.0484 42 10.181 42 7.79462 39.3188C5.40822 36.6378 5.82116 33.0994 6.64704 26.0226Z'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18 14C18 17.3137 20.6862 20 24 20C27.3138 20 30 17.3137 30 14'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
